export const DEFAULT_DEAD_DEVICE_MONTHS = 6;
export const MIN_DEAD_DEVICE_MONTHS = 1;
export const MAX_DEAD_DEVICE_MONTHS = 12;

export const DEAD_DEVICE_MONTH_OPTIONS = Array.from(
  { length: MAX_DEAD_DEVICE_MONTHS - MIN_DEAD_DEVICE_MONTHS + 1 },
  (_, index) => MIN_DEAD_DEVICE_MONTHS + index,
);

/** Срочное month choices: 1–6 and 8–12. Default is 4 months. */
export const URGENT_DEFAULT_DEAD_DEVICE_MONTHS = 4;
export const URGENT_DEAD_DEVICE_MONTH_OPTIONS = DEAD_DEVICE_MONTH_OPTIONS.filter((months) => months !== 7);

function monthLabel(months) {
  const mod10 = months % 10;
  const mod100 = months % 100;

  if (mod10 === 1 && mod100 !== 11) {
    return `${months} месяц`;
  }

  if (mod10 >= 2 && mod10 <= 4 && (mod100 < 12 || mod100 > 14)) {
    return `${months} месяца`;
  }

  return `${months} месяцев`;
}

export function formatDeadDeviceMonthOption(months) {
  return monthLabel(months);
}
